// src/constants/feature-flags.constants.ts
var ACHIEVEMENTS_ENABLED = "achievements_enabled";
var REWARDS_EVENTS_ENABLED = "rewards_events_updates";
var REWARDS_POINTS_ENABLED = "rewards_points";

// src/constants/message-type.constants.ts
var FETCH_AND_SYNC_ACHIEVEMENTS_UPDATES_MESSAGE_TYPE = "fetch_and_sync_achievement_updates";
var GET_ACHIEVEMENTS_STATS_MESSAGE_TYPE = "get_achievements_stats";
var GET_LEAGUE_POINTS_REWARD_LEVELS_MESSAGE_TYPE = "get_league_points_reward_levels";
var GET_RECENT_ACHIEVEMENTS_MESSAGE_TYPE = "get_recent_achievements";
var GET_USER_ACHIEVEMENTS_MESSAGE_TYPE = "get_user_achievements";
var GET_USER_LEAGUE_POINTS_REWARDS_BALANCE_MESSAGE_TYPE = "get_user_league_points_rewards_balance";

// src/requests/get-user-achievements.ts
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
var getUserAchievements = () => SocketAsFetch.fetch({
  message_type: GET_USER_ACHIEVEMENTS_MESSAGE_TYPE
});

// src/requests/get-recent-achievements.ts
import { SocketAsFetch as SocketAsFetch2 } from "@leagueplatform/socket-as-fetch";
var getRecentAchievements = () => SocketAsFetch2.fetch({
  message_type: GET_RECENT_ACHIEVEMENTS_MESSAGE_TYPE
});

// src/requests/get-achievements-stats.ts
import { SocketAsFetch as SocketAsFetch3 } from "@leagueplatform/socket-as-fetch";
var getAchievementsStats = () => SocketAsFetch3.fetch({
  message_type: GET_ACHIEVEMENTS_STATS_MESSAGE_TYPE
});

// src/requests/fetch-and-sync-achievement-updates.ts
import { SocketAsFetch as SocketAsFetch4 } from "@leagueplatform/socket-as-fetch";
var fetchAndSyncAchievementUpdates = () => SocketAsFetch4.fetch({
  message_type: FETCH_AND_SYNC_ACHIEVEMENTS_UPDATES_MESSAGE_TYPE
});

// src/requests/get-user-league-points-rewards-balance.ts
import { SocketAsFetch as SocketAsFetch5 } from "@leagueplatform/socket-as-fetch";
var getUserLeaguePointsRewardsBalance = () => SocketAsFetch5.fetch({
  message_type: GET_USER_LEAGUE_POINTS_REWARDS_BALANCE_MESSAGE_TYPE
});

// src/requests/get-league-points-reward-levels.ts
import { SocketAsFetch as SocketAsFetch6 } from "@leagueplatform/socket-as-fetch";
var getLeaguePointsRewardLevels = () => SocketAsFetch6.fetch({
  message_type: GET_LEAGUE_POINTS_REWARD_LEVELS_MESSAGE_TYPE
});
export {
  ACHIEVEMENTS_ENABLED,
  FETCH_AND_SYNC_ACHIEVEMENTS_UPDATES_MESSAGE_TYPE,
  GET_ACHIEVEMENTS_STATS_MESSAGE_TYPE,
  GET_LEAGUE_POINTS_REWARD_LEVELS_MESSAGE_TYPE,
  GET_RECENT_ACHIEVEMENTS_MESSAGE_TYPE,
  GET_USER_ACHIEVEMENTS_MESSAGE_TYPE,
  GET_USER_LEAGUE_POINTS_REWARDS_BALANCE_MESSAGE_TYPE,
  REWARDS_EVENTS_ENABLED,
  REWARDS_POINTS_ENABLED,
  fetchAndSyncAchievementUpdates,
  getAchievementsStats,
  getLeaguePointsRewardLevels,
  getRecentAchievements,
  getUserAchievements,
  getUserLeaguePointsRewardsBalance
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/rewards-api'] = window.leagueSDKsPresent['@leagueplatform/rewards-api'] || [];
    window.leagueSDKsPresent['@leagueplatform/rewards-api'].push('2.23.5');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/rewards-api'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/rewards-api module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map